<app-navbar-style-one></app-navbar-style-one>

<section class="sign-in-area ptb-100">
    <div class="container">
        <div class="contact-wrap-form">
            <div class="row" id="signinFormContainer">
                <div class="col-md-6 col-12 mt-2 signForm pt-5">
                    <form [formGroup]="signInForm">
                        <div class="mb-3 mt-4">
                            <label for="signinEmail" class="form-label">Email address or Phone<span class="text-danger">*</span></label>
                            <input type="email" class="form-control" id="signinEmail" 
                                placeholder="1234567890" name="phone" formControlName="phone" required>
                            <div *ngIf="signInForm.get('phone')?.hasError('required') && signInForm.get('phone')?.touched" class="text-danger mt-0">
                                <small style="color: red !important;">This field is required</small>
                            </div>
                        </div>
                        <div class="mb-3">
                            <label for="signinPassword" class="form-label">Password<span class="text-danger">*</span></label>
                            <input type="password" class="form-control" name="password" formControlName="password"
                                placeholder="****************" id="signinPassword" required>
                            <div *ngIf="signInForm.get('password')?.hasError('required') && signInForm.get('password')?.touched" class="text-danger mt-0">
                                <small style="color: red !important;">Password is required</small>
                            </div>
                            <div *ngIf="signInForm.get('password')?.hasError('minlength') && signInForm.get('password')?.touched" class="text-danger mt-0">
                                <small style="color: red !important;">
                                    Password must be at least 8 characters
                                </small>
                            </div>
                        </div>
                        <a style="color: #003921;text-decoration: underline;font-weight: 700;" class="mb-3 mt-2" href="/reset-password">Forgot password?</a>
                        <!-- <div class="d-grid gap-2">
                            <button type="submit" class="btn btn-primary py-2" [disabled]="isLoading">
                                <span *ngIf="isLoading" class="spinner-border spinner-border-sm me-1"></span>
                                Sign In
                            </button>
                        </div>-->
                    </form>                    
                </div>
                <div class="col-md-6 col-12 mt-2 pt-3">
                    <div class="m-5 text-center">
                        <!-- <img src="assets/img/home2/login.png" alt="Sign In Image"> -->
                        <h1 class="mt-3 signInTitle">Join the Flavor Club</h1>
                        <p class="mt-2 px-5 signInParagraph">Create your account to order faster, customize your pizza & burger, and enjoy exclusive deals.”</p>
                    </div>
                    <div class="mt-4 text-center">
                        <button type="submit" class="btn btn-primary py-2 px-5" [disabled]="isLoading" (click)="login()">
                            <span *ngIf="isLoading" class="spinner-border spinner-border-sm me-1"></span>
                            Sign In
                        </button>
                    </div>
                    <div class="d-grid gap-2 text-center mt-2">
                        <a (click)="enableGuestMode()" class="link">Continue as a guest</a>
                    </div>
                    <div class="mt-3 text-center">
                        <p class="newAccount">Do not have account yet ? <a href="/sign-up" class="link">Sign up</a></p>
                    </div>

                    <div class="mt-5 pb-4 text-start">
                        <p class="text-start" style="font-weight: 600;">By accessing this website, registering, or placing any order, you acknowledge and agree to be bound by the website’s Privacy Policy and Terms & Conditions.</p>
                    </div>
                </div>
            </div>

            <div class="row p-5 d-none" id="codeOTPErrorWhenLoginContainer">
                <!-- <div class="col-12 text-center">
                    <img src="assets/img/home2/verify.png" alt="Verify Image">
                </div> -->
                <div class="col-12 text-center">
                    <h1 class="mt-3 signInTitle">Verify Email</h1>
                    <p class="mt-5 px-5 signInParagraph">Please enter your email and we'll send you a 6-digit code to verify your account.</p>
                </div>
                <div class="col-12">
                    <form *ngIf="currentStep === 1" [formGroup]="resetForm" (ngSubmit)="sendOtpToMailIfLoginFailed()">
                        <div class="row">
                            <div class="col-12 px-5">
                                <div class="form-group mb-2">
                                    <label style="color: #003921 !important;" for="email" class="form-label">Email <span class="text-danger">*</span></label>
                                    <input class="form-control" type="email" name="email" formControlName="email" placeholder="Enter Your Email">
                                    <div *ngIf="resetForm.get('email')?.hasError('required') && resetForm.get('email')?.touched" class="text-danger text-small ps-3 mt-0">
                                        Email is required
                                    </div>
                                    <div *ngIf="resetForm.get('email')?.hasError('email') && resetForm.get('email')?.touched" class="text-danger text-small ps-3 mt-0">
                                        Enter a valid email address
                                    </div>
                                </div>
                            </div>

                            <div class="col-12 text-center">
                                <button class="btn btn-primary" type="submit" [disabled]="isLoading">
                                    <span *ngIf="isLoading" class="spinner-border spinner-border-sm me-1"></span>
                                    Send OTP
                                </button>
                            </div>
                        </div>
                    </form>
                </div>
            </div>

            <div class="row p-5 d-none" id="verifyOTPWhenLoginContainer">
                <!-- <div class="col-12 text-center">
                    <img src="assets/img/home2/otp.png" alt="OTP Image">
                </div> -->
                <div class="col-12 text-center">
                    <h1 class="mt-3 signInTitle">Verify OTP</h1>
                    <p class="recover-text">We've sent a 6-digit code to <strong>{{resetForm.value.email}}</strong></p>
                </div>
                <div class="col-12">
                    <div class="scetion-title text-center" *ngIf="currentStep === 2">                        
                        <form [formGroup]="otpCodeForm" (ngSubmit)="verifyOtp2()">
                            <div class="row justify-content-center">
                                <div class="col-12">
                                    <div class="otp-input-group">
                                        <input type="text" maxlength="1" (input)="moveToNext2($event, 1)" #otp1>
                                        <input type="text" maxlength="1" (input)="moveToNext2($event, 2)" #otp2>
                                        <input type="text" maxlength="1" (input)="moveToNext2($event, 3)" #otp3>
                                        <input type="text" maxlength="1" (input)="moveToNext2($event, 4)" #otp4>
                                        <input type="text" maxlength="1" (input)="moveToNext2($event, 5)" #otp5>
                                        <input type="text" maxlength="1" (input)="moveToNext2($event, 6)" #otp6>
                                    </div>
                                    <input type="hidden" formControlName="otp_code">
                                    <div *ngIf="otpCodeForm.get('otp_code')?.hasError('required')" class="text-danger text-small text-center mt-2">
                                        OTP is required
                                    </div>
                                </div>
                                <!-- <div class="col-12 text-end mt-4">
                                <span class="text-muted" *ngIf="countdown > 0">
                                    {{countdown}} seconds
                                </span>
                                </div> -->
                                <div class="d-flex justify-content-between mb-3">
                                    <button type="button" class="btn btn-link" [disabled]="countdown != 0" (click)="resendOtp()">
                                        Resend Code
                                    </button>
                                    <span class="text-muted" *ngIf="countdown > 0">
                                        {{countdown}} seconds
                                    </span>
                                </div>
                                <div class="col-12 text-center mt-4">
                                    <button class="btn btn-primary w-100 me-2" type="submit" [disabled]="isLoading">
                                        <span *ngIf="isLoading" class="spinner-border spinner-border-sm me-1"></span>
                                        Verify
                                    </button>
                                    <!-- <button class="btn btn-outline-secondary" type="button" (click)="resendOtp()" [disabled]="disableBtnBeforeResendOTP">
                                        <span *ngIf="isResending" class="spinner-border spinner-border-sm me-1"></span>
                                        Resend OTP
                                    </button> -->
                                </div>
                            </div>
                        </form>
                    </div>
                </div>
            </div>
            <!-- <div class="scetion-title text-center">
                <span>Sign In</span>
                <h2>Sign In to your account!</h2>
                <p>with your social network</p>
                <ul class="sign-social-icon">
                    <li><a href="#"><i class='bx bxl-facebook'></i></a></li>
                    <li><a href="#"><i class='bx bxl-twitter' ></i></a></li>
                    <li><a href="#"><i class='bx bxl-google-plus'></i></a></li>
                </ul>
            </div> -->

            
        </div>
    </div>
</section>

<app-footer-style-two></app-footer-style-two>